const DEFAULTS = {
  GVM_ROUTE: "/fulfilment/partner/api/v1/vendors",
  GVM_BOUNCER_ROUTE: "/fulfilment/accounts-payable/api/v1/vendors",
  GVM_EDIT_ROUTE: "/vip/gvm/api/v1",
  RFQ_ROUTE: "/fulfilment/accounts-payable/api/v1/vip/rfq-invitations",
} as const;

export type ApiPathKey = keyof typeof DEFAULTS;

function apiPath(key: ApiPathKey): string {
  const raw =
    (typeof window !== "undefined" && window.config?.API_PATHS?.[key]) ||
    DEFAULTS[key];
  return raw.endsWith("/") ? raw.slice(0, -1) : raw;
}

export function gvmPath(endpoint: string): string {
  const leading = endpoint.startsWith("/") ? endpoint : `/${endpoint}`;
  return `${apiPath("GVM_ROUTE")}${leading}`;
}

export function gvmBouncerPath(endpoint: string): string {
  const leading = endpoint.startsWith("/") ? endpoint : `/${endpoint}`;
  return `${apiPath("GVM_BOUNCER_ROUTE")}${leading}`;
}

export function gvmEditPath(endpoint: string): string {
  const leading = endpoint.startsWith("/") ? endpoint : `/${endpoint}`;
  return `${apiPath("GVM_EDIT_ROUTE")}${leading}`;
}

export function rfqPath(endpoint: string): string {
  if (!endpoint) return apiPath("RFQ_ROUTE");
  const leading = endpoint.startsWith("/") ? endpoint : `/${endpoint}`;
  return `${apiPath("RFQ_ROUTE")}${leading}`;
}
